import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Icon, Button, Label } from "semantic-ui-react";
import Sidebar from "../../../app/common/util/Sidebar";
import NavBar from "../../nav/NavBar/NavBar";
import OrderDetails from "./OrderDetails";
import { connect } from "react-redux";
import { isEmpty } from "../../../app/common/util/genericUtils";
import { getOrderDetailsForPage } from "../homeActions";
import SimplePageLoader from "../../../app/common/util/SimplePageLoader";
import OrderDetailsActions from "./OrderDetailsActions";
import { Row, Col } from "antd";
import StockOrderDetails from "./StockOrderDetails";
import OrderMetaSummaryCard from "./OrderMetaSummaryCard";

class OrderDetailsPage extends Component {
  state = {};
  componentWillMount() {
    const {
      match: { params },
      details,
      getOrderDetailsForPage
    } = this.props;

    if (isEmpty(details)) {
      getOrderDetailsForPage(params.id);
    }
  }
  render() {
    const { details, loadingOrderData } = this.props;
    if (loadingOrderData || isEmpty(details)) {
      return <SimplePageLoader label="Loading order…" />;
    }
    return (
      <div
        className={`order-details-page${
          details.status === "on_hold" ? " order-details-page--onhold" : ""
        }`}
      >
        <NavBar />
        <Sidebar />
        <div className="order-details-top">
          <div className="order-details-page-header">
            <Button
              as={Link}
              to="/"
              icon
              labelPosition="left"
              className="order-details-back-btn"
            >
              <Icon name="left arrow" />
              Back to Orders
            </Button>
            {details && details.linked_order !== null && (
              <Row className="order-details-linked-row">
                <Col span={4}>
                  <h2>Linked Order: </h2>
                </Col>
                <Col span={4}>
                  <p
                    style={{ marginTop: "4%" }}
                    className="validate-link"
                    onClick={() =>
                      this.props.getOrderDetailsForPage(
                        details.linked_order.id
                      )
                    }
                  >
                    {details.linked_order.internal_order_id}
                  </p>
                </Col>
                <Col span={16}>
                  {details && details.reason_for_linking !== null && (
                    <Label basic color="blue">
                      {"Linking Reason:" + details.reason_for_linking}
                    </Label>
                  )}
                </Col>
              </Row>
            )}
            <div className="order-details-meta-wrap">
              <OrderMetaSummaryCard
                source={details.source}
                author={details.author}
                authorisedBy={details.authorised_by}
              />
            </div>
          </div>
          <OrderDetailsActions
            id={details.id}
            status={details.status}
            details={details}
          />
        </div>
        {details.is_stock === false ? (
          <OrderDetails
            details={details}
            highlightedFields={highlightedFields}
            id={details.id}
          />
        ) : (
          <StockOrderDetails details={details} />
        )}
      </div>
    );
  }
}
const mapStateToProps = state => ({
  details: state.home.orderDetails,
  loadingOrderData: state.home.loadingOrderData,
});
const actions = {
  getOrderDetailsForPage
};
export default connect(
  mapStateToProps,
  actions
)(OrderDetailsPage);

const highlightedFields = {
  lnam: "lnam",
  sph: "sph",
  customer: "customer",
  add: "add",
  received_date: "received_date"
};
